// extracted by mini-css-extract-plugin
export default {"tooltip":"op-z","sharingV2":"pp-z","sharingIconsV2":"qp-z","links":"rp-z","link":"sp-z","facebookV2":"tp-z","twitterV2":"up-z","pinterestV2":"vp-z"};